import { Injectable } from '@angular/core';
import { RxStompService } from '@stomp/ng2-stompjs';
import { Message } from '@stomp/stompjs';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ReportService } from './report.service';
import { ToasterService } from './toaster.service';
import { UserService } from './user.service';

@Injectable()
export class SocketService {
  private reportStompSubscription: Subscription;
  private userStompSubscription: Subscription;

  private connectionToastOpen: boolean = false;

  constructor(private stompService: RxStompService,
    private reprotService: ReportService,
    private userService: UserService,
    private toastr: ToasterService) {

    stompService.connectionState$.subscribe(state => {
      // state is an Enum (Integer), RxStompState[state] is the corresponding string
      if (environment.SHOW_DEBUG) {
        if (state === 3 && !this.connectionToastOpen) {
          this.connectionToastOpen = true;
          this.toastr.connectionLost();
        } else if (state === 1 && this.connectionToastOpen) {
          this.connectionToastOpen = false;
          this.toastr.closeConnectionToastr();
        }
      }
    });

  }

  setAuthToken(): void {
    this.stompService.configure({
      connectHeaders: {
        ACCESS_TOKEN: localStorage.getItem(environment.TOKEN_NAME)
      }
    })
  }

  disconnect(): void {
    this.stompService.deactivate();
  }

  connect(): void {
    this.stompService.activate();
  }

  subscribeToReport(id: string): void {
    this.reportStompSubscription = this.stompService.watch(`/report/${id}`)
      .subscribe((message: Message) => this.onReportMessageReceived(message.body));
  }

  unsubscribeFromReport(): void {
    if (this.reportStompSubscription)
      this.reportStompSubscription.unsubscribe();
  }

  /*** Process Received Message for Report */
  private onReportMessageReceived(message: string): void {
    if (environment.SHOW_DEBUG) {
      console.log(JSON.parse(message));
    }
    this.reprotService.wsMessageReceived(JSON.parse(message));
  }


  subscribeToUser(id: string): void {
    this.userStompSubscription = this.stompService.watch(`/user/${id}`)
      .subscribe((message: Message) => this.onUserMessageReceived(message.body));
  }

  unsubscribeFromUser(): void {
    if (this.userStompSubscription)
      this.userStompSubscription.unsubscribe();
  }

  /*** Process Received Message for User */
  private onUserMessageReceived(message: string): void {
    this.userService.wsMessageReceived(JSON.parse(message));
  }

}
